module.exports = __webpack_public_path__ + "static/media/Kissen_40x40.d469590a.png";